import { OktaStoreEnum } from '../oktaClient.enum';
import { IOktaStorage } from '../oktaClient.interface';
import { storageLocationBuilders } from './storageLocationBilder';

export const storageFactory = (location: OktaStoreEnum): IOktaStorage => {
  return storageLocationBuilders[location];
};
